module.exports = __webpack_public_path__ + "static/media/snackbar-success.9f4d2126.svg";